<template>
  <div class="history-chart-warp">
    <div class="graph-wrapper" ref="DoubleGraph" :class="[statusClass]"></div>
    <div v-if="useHumiditySectionLine" class="history-ts">适用湿度范围 {{range}}</div>
  </div>
</template>
<script>
  export default {
    name: 'HistoryData',
    props: {
      title: String,
      series: Array,
      legendData: {
        type: Array,
        default() {
          return []
        }
      },
      statusClass: String,
      useHumiditySectionLine: Boolean,
      humiditySectionLineMax: Number,
      range: String
    },
    watch: {
      series(val) {
        this.updateSerise(val)
      }
    },
    data() {
      return {
        graph: null
      }
    },
    mounted() {
      this.initGraph()
    },
    methods: {
      initGraph() {
        this.graph = this.$echarts.init(this.$refs.DoubleGraph)
        this.graph.showLoading()
        window.addEventListener('resize', () => {
          this.graph.resize()
        })
      },
      updateSerise(seriesData = []) {
        const that = this
        const $series = []
        let formatter = '{b} <br/>'
        this.legendData.forEach((val, $index) => {
          const obj = {
            name: val,
            smooth: true,
            type: 'line',
            markPoint: { data: [] },
            showSymbol: false,
            data: [],
            lineStyle: { normal: { color: '#3f4b83', opacity: 0 } },
            areaStyle: { normal: { color: '#3f4b83', opacity: 0.9 } }
          }
          if (this.useHumiditySectionLine) {
            obj.markLine = {
              itemStyle: {
                normal: { lineStyle: { type: 'solid' }, label: { show: true, position: 'end' } },
              },
              data: [
                {
                  name: '下限',
                  type: 'average',
                  yAxis: JSON.parse(this.range)[0],
                  lineStyle: { color: 'green' }
                },
                {
                  name: '上限',
                  yAxis: JSON.parse(this.range)[1],
                  lineStyle: { color: 'red' }
                }
              ]
            }
          }
          $series.push(obj)
          formatter += '{a' + $index + '} : {c' + $index + '}<br/>'
        })
        const option = {
          backgroundColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(255, 255, 255, 0)' },
              { offset: 1, color: 'rgba(255, 255, 255, 0)' }
            ]
          },
          color: ['#545e8c', '#213784'],
          title: {
            text: this.title,
            left: '1%',
            top: '2%',
            textStyle: { color: '#000', fontWeight: '400' }
          },
          legend: {
            bottom: '0',
            right: '5px',
            // selectedMode: false,
            textStyle: { color: '#000' },
            icon: 'bar',
            data: this.legendData
          },
          grid: {
            left: '10px', right: '20px', top: '60px', bottom: '30px', containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            padding: 10,
            showTitle: false,
            backgroundColor: 'rgba(245, 245, 245, 0.8)',
            axisPointer: { type: 'line' },
            textStyle: { color: '#000' },
            formatter: formatter
          },
          xAxis: {
            type: 'category',
            maxInterval: 1,
            z: 5,
            boundaryGap: false,
            splitLine: { show: true, lineStyle: { color: '#eee' } },
            axisLine: { lineStyle: { color: '#888' } },
            axisTick: { show: false },
            axisLabel: { textStyle: { color: '#333' }, show: false }
          },
          yAxis: {
            z: 5,
            type: 'value',
            max: function (value) {
              let cha = (that.useHumiditySectionLine ? that.humiditySectionLineMax : 0) - value.max
              return value.max + (cha > 0 ? cha : 0) + 5
            },
            axisLine: { lineStyle: { color: '#888' } }, // 左侧边框
            splitLine: { show: true, lineStyle: { color: '#eee' } }, // 横坐标轴
            axisTick: { show: true },
            axisLabel: { textStyle: { color: '#333' } } // y轴文字颜色
          },
          series: $series
        }
        const xA = []
        const dataList = []
        seriesData.forEach(val => {
          const ary = []
          const keys = Object.keys(val)
          keys.forEach(key => {
            if (xA.length < keys.length && keys.length > 0) xA.push(key)
            ary.push(val[key])
          })
          dataList.push(ary)
        })
        dataList.forEach((list, $index) => {
          if (list.length === 0) {
            option.series[$index].data = new Array(xA.length).fill('--')
          } else {
            option.series[$index].data = list
          }
        })
        option.xAxis.data = xA
        that.graph.hideLoading()
        that.graph.setOption(option)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .graph-wrapper {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
  }

  .history-chart-warp {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .history-ts {
    position: absolute;
    width: 160px;
    text-align: center;
    font-size: 12px;
    color: #666;
    top: 15px;
    left: 50%;
    margin-left: -80px;
  }
</style>
